import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { FileField } from "seed/helpers";
import { usePost } from "seed/api";
import Table from "components/collections/Table";
import l from "components/util/l";

const ExcelField = forwardRef(({
  dataWrapper = true,
  isSingleImport = false,
  defaultFile = null,
  defaultSelectedSheet = null,
  defaultOffset = 0,
  defaultDataOffset = 0,
  referenceColumns = [],
  overrideColumns = false,
  showAdvancedOptions = true,
  showPreview = true,
  showError = false,
  rowLimit,
  setLoading = () => { },
  onLoadFile = () => { },
  onDownloadTemplate = () => { },
}, ref) => {

  const [file, setFile] = useState(defaultFile);
  const [selectedSheet, setSelectedSheet] = useState(defaultSelectedSheet);
  const [skipRows, setSkipRows] = useState(defaultOffset);
  const [skipDataRows, setSkipDataRows] = useState(defaultDataOffset);
  const [sheets, setSheets] = useState([]);
  const [status, setStatus] = useState(null);
  const [data, setData] = useState(null);

  const [callReadFile, reqReadFile] = usePost("/apps/excel/read", {
    onCompleted: (data) => {
      setSheets(data.sheets || []);
      setData({
        file: file,
        offset: skipRows,
        data_offset: skipDataRows,
        sheet: data.sheet,
        rows: data.rows,
        columns: data.columns,
        error: false,
      });
    },
    onError: () => {
      setData({
        file: file,
        offset: skipRows,
        data_offset: skipDataRows,
        sheet: null,
        rows: [],
        columns: [],
        error: true,
      });
    }
  });

  const onUploadFile = () =>
    callReadFile({
      file: file,
      sheet_name: selectedSheet,
      headers: overrideColumns ? referenceColumns : null,
      offset: skipRows,
      data_offset: skipDataRows,
      data_wrapper: dataWrapper,
      limit: rowLimit,
    });

  useEffect(() => {
    if (data) onLoadFile(data);
  }, [data]);

  useEffect(() => {
    if (file) {
      setStatus(null);
      onUploadFile(file);
    }
  }, [file, selectedSheet, skipRows, skipDataRows, overrideColumns]);

  useImperativeHandle(ref, () => ({
    status,
    setStatus: (status) => setStatus(status),
    setOffset: (offset) => setSkipRows(offset)
  }));

  const isLoading = reqReadFile.loading;

  return <div className="input-excel">

    {
      isSingleImport && <>

        <div className="mt-1">
          <div className="form-group mb-0">
            {
              data?.error &&
              <div className="text-danger">
                <i className="fa fa-exclamation mr-2"></i> {l("Las columnas del Excel no coinciden%SC170")}
              </div>
            }
            <FileField
              name="file"
              id="file"
              required={true}
              class="form-control form-control-lg"
              accept=".csv, .xls, .xlsx"
              setFieldValue={() => { }}
              onCompleted={setFile}
              setLoading={setLoading}
            />
            {
              !data &&
              <input
                type="file"
                name={"excel_field_error"}
                value={data?.toString() || ""}
                required
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  opacity: 0,
                  zIndex: -1,
                  cursor: "pointer"
                }}
              />
            }
          </div>
        </div>

        {
          sheets.length > 1 && <>
            <div className="mt-2">
              <div>
                {l("Hoja a cargar%CA106")}
              </div>
            </div>
            <div className="mt-1 mb-3 mr-5">
              <div className="form-group mb-1">
                <select
                  className="form-control form-control-sm"
                  value={selectedSheet}
                  onChange={(e) => setSelectedSheet(e.target.value)}
                >
                  {
                    sheets.map((sheet, i) => <option key={i} value={sheet}>{sheet}</option>)
                  }
                </select>
              </div>
            </div>
          </>
        }

        {
          showAdvancedOptions && data &&
          <>
            <button
              type="button"
              className="btn btn-link mt-2 m-0 p-0"
              data-toggle="collapse"
              data-target="#excel-advanced-options"
              aria-expanded="false"
              aria-controls="excel-advanced-options"
            >
              {l("Opciones avanzadas%SA220")} <i className="fas fa-chevron-down"></i>
            </button>

            <div
              id="excel-advanced-options"
              className="collapse"
            >

              {
                data &&
                <div className="mt-2">
                  <div>
                    <span className="h5 font-weight-light">
                      {l("Indica las filas a ignorar%VF078")}
                    </span>
                  </div>
                  <div className="mt-2">
                    <div class="form-group mb-2">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={skipRows}
                        onChange={(e) => setSkipRows(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              }

            </div>
          </>
        }

      </>
    }

    {
      !isSingleImport && <>
        <div className="h5 text-primary mb-3">
          {l("Instrucciones%CA102", null, "AA")}
        </div>
        <div>
          <div>
            <span className="h5 text-primary mr-1">
              1.
            </span>
            <span className="text-dark">
              {l("Descarga tu datos actuales y actualízalos%CA103")}
              <small style={{ color: "#aaa", fontSize: "0.8rem" }}> ({l("Opcional%GA024")})</small>
            </span>
          </div>
          <div>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm mt-2"
              onClick={onDownloadTemplate}
            >
              {l("Descargar%GA027")}
            </button>
          </div>
        </div>
        <div className="mt-3">
          <div>
            <span className="h5 text-primary mr-1">
              2.
            </span>
            <span className="text-dark">
              {l("Sube el archivo Excel%CA105")}
            </span>
          </div>
        </div>
        <div className="mt-2 pb-2">
          <div>
            <div class="form-group mb-0">
              {
                isLoading
                  ? <i className="fas fa-spinner fa-spin mr-2"></i>
                  : <FileField
                    name="file"
                    id="file"
                    required={true}
                    class="form-control form-control-lg"
                    accept=".csv, .xls, .xlsx"
                    setFieldValue={() => { }}
                    onCompleted={setFile}
                  />
              }
            </div>
          </div>
        </div>

        {
          sheets.length > 0 && <>
            <div className="mt-2">
              <div>
                <span className="h5 font-weight-light">
                  {l("Hoja a cargar%CA106")}
                </span>
              </div>
            </div>
            <div className="mt-2">
              <div class="form-group mb-1">
                <select
                  className="form-control form-control-sm"
                  value={selectedSheet}
                  onChange={(e) => setSelectedSheet(e.target.value)}
                >
                  {
                    sheets.map((sheet, i) => <option key={i} value={sheet}>{sheet}</option>)
                  }
                </select>
              </div>
            </div>
          </>
        }

        {
          (data || sheets.length > 0) &&
          <button
            type="button"
            className="btn btn-link mt-2 m-0 p-0"
            data-toggle="collapse"
            data-target="#excel-advanced-options"
            aria-expanded="false"
            aria-controls="excel-advanced-options"
          >
            {l("Opciones avanzadas%SA220")} <i className="fas fa-chevron-down"></i>
          </button>
        }

        <div
          id="excel-advanced-options"
          className="collapse"
        >

          {
            data &&
            <div className="mt-2">
              <div>
                <span className="h5 text-primary mr-1">
                  4.
                </span>
                <span className="h5 font-weight-light">
                  {l("Indica las filas a ignorar%VF078")}
                </span>
              </div>
              <div className="mt-2">
                <div class="form-group mb-0">
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    onChange={(e) => setSkipRows(e.target.value)}
                    value={skipRows}
                  />
                </div>
              </div>
            </div>
          }

        </div>

      </>
    }

    {
      status && <div className={`alert alert-${status.type} mt-3`} role="alert">
        <i className={`fa fa-${status.type == "success" ? "check" : "warning"}`}></i> {status.message}
      </div>
    }

    {
      status?.logs?.length > 0 && <div>
        {
          status.logs.map((log, i) => <div key={`${log.message}-${i}`}>
            <div className={`text-${log.type == "success" ? "success" : "danger"}`}>
              <i className={`fa fa-${log.type == "success" ? "check" : "exclamation"}`}></i> {log.message}
            </div>
          </div>)
        }
      </div>
    }

    {
      showPreview && data && data?.rows?.length > 0 &&
      <div className="w-100 overflow-auto mt-2">
        <Table
          showExport={false}
          showFilters={false}
          showPagination={false}
          showForm={false}
          showImport={false}
          showSearch={false}
          isReadOnly={true}
          structure={data.columns}
          values={data.rows}
        />
      </div>
    }

  </div >;

});

ExcelField.displayName = "ExcelField";

export default ExcelField;